import {
  AbstractBffApi,
  JsonResponseAppClientsInterface,
  JsonResponseHelpInterface,
  JsonResponseListofNewsInterface,
  JsonResponseLoggedinfoInterface,
  JsonResponseLogsInterface,
  JsonResponseNotLoggedinfoInterface,
  JsonResponseServicesInterface,
  JsonResponseToolurltokenInterface,
  JsonTokenInterface,
  JsonUserinfoInterface,
  OrderType
} from './sharedinterface';
import {Observable} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import * as moment from 'moment';

export class BffApi extends AbstractBffApi {

  login(encryptedCredential: string): Observable<JsonTokenInterface> {
    // todo Test date.now with Internet Explorer and use polyfills
    const nowtime = Date.now();
    const timeZoneOffset = new Date().getTimezoneOffset();
    const formData = new FormData();
    const options = {
      headers: new HttpHeaders({cr: encryptedCredential})
    };
    const url = '/login' + '?t=' + nowtime;
    return this.http.post<JsonTokenInterface>(this.serverRoot + url, {timeZoneOffset}, options);
  } // login

  logout(): Observable<any> {
    const formData = new FormData();
    const url = '/v1/logout';
    return this.http.post(this.serverRoot + url, formData);
  } // logout

  checkuser(): Observable<JsonUserinfoInterface> {
    const nowtime = Date.now();
    const formData = new FormData();
    const url = '/v1/users' + '?t=' + nowtime;
    return this.http.post<JsonUserinfoInterface>(this.serverRoot + url, formData);
  } // checkuser

  getAssets(link: string): string {
    return this.serverRoot + link;
  } // getAssets


  getloggedinfo(languagekey: string): Observable<JsonResponseLoggedinfoInterface> {
    const formData = new FormData();
    formData.append('languagekey', languagekey);
    const url = '/v1/loggedinfo';
    return this.http.post<JsonResponseLoggedinfoInterface>(this.serverRoot + url, formData);
  } // getloggedinfo

  gethelp(languagekey: string): Observable<JsonResponseHelpInterface> {
    const url = '/v1/help?lang=' + languagekey;
    return this.http.get<JsonResponseHelpInterface>(this.serverRoot + url);
  } // gethelp


  getsiteinfo(): Observable<JsonResponseNotLoggedinfoInterface> {
    const url = '/siteinfo';
    return this.http.get<JsonResponseNotLoggedinfoInterface>(this.serverRoot + url);
  } // getsiteinfo

  gettoollogin(toolid: number, toolkeyword: string, languagekey: string, params: string = '')
    : Observable<JsonResponseToolurltokenInterface> {
    const formData = new FormData();
    formData.append('toolid', toolid.toString());
    formData.append('toolkeyword', toolkeyword);
    formData.append('languagekey', languagekey);
    formData.append('params', params);
    const url = '/v1/tools/toolurltoken';
    return this.http.post<JsonResponseToolurltokenInterface>(this.serverRoot + url, formData);

  } // gettoollogin

  setAOSSid(sid: string, toolurl: string): Observable<any> {
    const formData = new FormData();
    const options = {
      headers: new HttpHeaders({cr: sid, toolurl})
    };
    const url = '/v1/aossid';
    return this.http.post(this.serverRoot + url, formData, options);
  } // setAOSSid

  getmandantnews(mandanid: string, lngid: number, origin: string, simorigin: string): Observable<JsonTokenInterface> {
    // const results = {
    //   label: 'Welcome',
    //   imgpath: 'https://aos.longines.com/html/img/longines/headlogo.png',
    //   content: {
    //     title: 'Welcome',
    //     body : '<p>Cher client AOS,</p>\n' +
    //       // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:max-line-length
    //       '<div>Le d&eacute;partement de production de Calitho restera ferm&eacute; &agrave;&nbsp;l&rsquo;Ascension le 21 mai 2018.</div>\n' +
    //       '<div>Vos commandes pass&eacute;es durant ce laps de temps seront trait&eacute;es le 22 mai.</div>\n' +
    //       '<div>Merci de votre compr&eacute;hension.</div>'
    //   },
    // };
    // // appClient_fkID	aopTool_fkID	Title_lngKeyword_fkID	Content_lngKeyword_fkID
    //
    // // created: '2015-04-09 08:13:02',
    // //  changed: '2015-04-09 08:13:02',
    // //  validefrom: '2016-03-01',
    // //  valideto: '2016-03-01',
    // //   eventdate: '2015-04-09 08:13:02',


    const formData = new FormData();
    formData.append('origin', origin);
    formData.append('simorigin', simorigin);

    // Example : /news?mandant=1&lng=1
    const url = '/news' + '?mandant=' + mandanid + '&lng=' + lngid;
    return this.http.post<JsonTokenInterface>(this.serverRoot + url, formData);

  } // getmandantnews


  getmandantnews2(languagekey: string): Observable<JsonResponseListofNewsInterface> {
    const formData = new FormData();
    formData.append('languagekey', languagekey);
    const url = '/v1/news';
    return this.http.post<JsonResponseListofNewsInterface>(this.serverRoot + url, formData);
  }

  getLastLogs(): Observable<JsonResponseLogsInterface> {
    const url = '/v1/admin/lastlogs';
    return this.http.get<JsonResponseLogsInterface>(this.serverRoot + url);
  }

  getToolkeywordTranslation(languagekey: string): Observable<any> {
    const url = '/v1/toolkeywordtranslation/' + languagekey;
    return this.http.get<JsonResponseAppClientsInterface>(this.serverRoot + url);
  }

  getClients(): Observable<JsonResponseAppClientsInterface> {
    const url = '/v1/admin/clients';
    return this.http.get<JsonResponseAppClientsInterface>(this.serverRoot + url);
  }

  getServices(): Observable<JsonResponseServicesInterface> {
    const url = '/v1/admin/services';
    return this.http.get<JsonResponseServicesInterface>(this.serverRoot + url);
  }

  getBlockedServices(): Observable<JsonResponseServicesInterface> {
    const url = '/v1/admin/blockedservices';
    return this.http.get<JsonResponseServicesInterface>(this.serverRoot + url);
  }

  getLngUserPreference(): Observable<any> {
    const url = '/v1/languagepreference';
    return this.http.get<any>(this.serverRoot + url);
  }

  getAOSOrderProductTypes(): Observable<any> {
    const url = '/v1/order/aos/producttypes';
    return this.http.get<any>(this.serverRoot + url);
  }

  getAOSOrderUsers(): Observable<any> {
    const url = '/v1/order/aos/users';
    return this.http.get<any>(this.serverRoot + url);
  }

  getAOSOrderCountries(): Observable<any> {
    const url = '/v1/order/aos/markets';
    return this.http.get<any>(this.serverRoot + url);
  }

  getAOSOrderCompanies(): Observable<any> {
    const url = '/v1/order/aos/companies';
    return this.http.get<any>(this.serverRoot + url);
  }

  geteditprofilviewinterface(languagekey: string): Observable<any> {
    console.log(languagekey);
    const formData = new FormData();

    formData.append('languagekey', languagekey);
    const url = '/v1/userprofileview';
    return this.http.post(this.serverRoot + url, formData);
  }

  requestPasswordReset(usernameOrEmail: string): Observable<any> {
    const formData = new FormData();
    formData.append('usernameOrEmail', usernameOrEmail);
    const url = '/requestpasswordreset';
    return this.http.post(this.serverRoot + url, formData);
  }

  setNewPassword(encryptedNewPasswordData: string): Observable<any> {
    const formData = new FormData();
    const options = {
      headers: new HttpHeaders({cr: encryptedNewPasswordData})
    };
    const url = '/setnewpassword';
    return this.http.post(this.serverRoot + url, formData, options);
  }

  getRecentOrders(orderType: OrderType): Observable<any> {
    return this.http.get(this.serverRoot + '/v1/orders/' + orderType);
  }

  getAOSRoles(usertoolid: string): Observable<any> {
    return this.http.get(this.serverRoot + '/v1/admin/aosroles?usertoolid=' + usertoolid);
  }

  getAOSAppClients(usertoolid: string): Observable<any> {
    return this.http.get(this.serverRoot + '/v1/admin/aosclients?usertoolid=' + usertoolid);
  }

  searchOrders(searchObject: any): Observable<any> {

    const searchData = {
      startDate: moment(searchObject.fromDate).format('YYYY/MM/DD'),
      endDate: moment(searchObject.untilDate).format('YYYY/MM/DD'),
      productTypeId: searchObject.productTypeId,
      marketId: searchObject.marketId,
      companyId: searchObject.companyId,
      userId: searchObject.userId,
      textSearch: searchObject.textSearch
    };

    const url = '/v1/orders/' + searchObject.orderType + '/search';
    return this.http.post(this.serverRoot + url, JSON.stringify(searchData));
  }

  getAOSCompanies(apiaosroot: string, username: string, mandantkey: string): Observable<any> {
    return this.http.get(apiaosroot + '/companies?username=' + username + '&mandant=' + mandantkey);
  }

  getAOSToolRoles(apiaosroot: string, username: string, mandantkey: string): Observable<any> {
    return this.http.get(apiaosroot + '/roles?username=' + username + '&mandant=' + mandantkey);
  }

  getAOSToolRights(apiaosroot: string, username: string, mandantkey: string): Observable<any> {
    return this.http.get(apiaosroot + '/rights?username=' + username + '&mandant=' + mandantkey);
  }

  setAOSUserTool(apiaosroot: string, body: any): Observable<any> {
    return this.http.post(apiaosroot + '/usertools', body);
  }

}
